<template>
    <div
        v-if="hasSuggestions"
        class="suggestion_user_list_wrp"
    >
        <ul class="suggestion_user_list_item">
            <!-- Team option -->
            <li
                v-if="showTeamOption"
                data-attr="team"
                role="button"
                tabindex="0"
                aria-label="Mention all members"
                @click="selectedSuggestedUserInfo(team)"
            >
                <span class="suggestion_user_info">
                    <span
                        class="
                            suggestion_user_info_name
                            suggestion_user_info_name--team
                        "
                    >
                        Team
                    </span>

                    <span class="suggestion_user_info_email">
                        All Members
                    </span>
                </span>
            </li>

            <!-- User list -->
            <li
                v-for="item in filteredUsers"
                :key="item.id"
                :data-attr="getUserDisplayName(item)"
                role="button"
                tabindex="0"
                :aria-label="'Mention ' + getUserDisplayName(item)"
                @click="selectedSuggestedUserInfo(item)"
            >
                <span class="suggestion_user_info">
                    <span class="suggestion_user_info_name">
                        {{ getUserDisplayName(item) }}
                    </span>

                    <span class="suggestion_user_info_email">
                        {{ item.handle || item.login || item.username }}
                    </span>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import { bus } from '@/main'

export default {
    name: 'ChatForUserSuggestionList',

    props: {
        selectedGroupID: {
            type: [String, Number],
            default: null
        },

        messageContentDraftVAL: {
            type: String,
            default: ''
        },

        value: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    data() {
        return {
            team: {
                id: 'team',
                handle: 'team'
            }
        }
    },

    computed: {
        groupUsers() {
            const response =
                this.$store.getters.groupUserNamesGetters

            if (Array.isArray(response)) {
                return response
            }

            if (
                response &&
                Array.isArray(response.data)
            ) {
                return response.data
            }

            return []
        },

        mentionSearchValue() {
            const content = String(
                this.messageContentDraftVAL || ''
            )

            const lastAtIndex = content.lastIndexOf('@')


            if (lastAtIndex === -1) {
                return ''
            }

            return content
                .slice(lastAtIndex + 1)
                .trim()
                .toLowerCase()
        },

        filteredUsers() {
            const searchValue = this.mentionSearchValue

            if (!searchValue) {
                return this.groupUsers
            }

            return this.groupUsers.filter((item) => {
                const searchableContent = [
                    item.first_name,
                    item.last_name,
                    item.handle,
                    item.id
                ]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase()

                return (
                    searchableContent.indexOf(
                        searchValue
                    ) !== -1
                )
            })
        },

        showTeamOption() {
            const searchValue = this.mentionSearchValue

            if (!searchValue) {
                return true
            }

            return (
                'team all members'.indexOf(
                    searchValue
                ) !== -1
            )
        },

        hasSuggestions() {
            return (
                this.showTeamOption ||
                this.filteredUsers.length > 0
            )
        }
    },

    watch: {
        selectedGroupID: {
            immediate: true,

            handler(groupID) {
                if (
                    groupID === null ||
                    typeof groupID === 'undefined' ||
                    groupID === ''
                ) {
                    return
                }

                this.$store.dispatch(
                    'fetchGroupUserNames',
                    {
                        id: groupID
                    }
                )
            }
        }
    },

    methods: {
        getUserDisplayName(user) {
            if (!user) {
                return ''
            }

            const fullName = [
                user.first_name,
                user.last_name
            ]
                .filter(Boolean)
                .join(' ')
                .trim()

            return (
                fullName ||
                user.handle ||
                user.id ||
                'Unknown user'
            )
        },

        selectedSuggestedUserInfo(user) {
            if (!user) {
                return
            }

            const handle =
                user.handle ||
                user.id

            if (!handle) {
                return
            }

            const normalizedHandle =
                String(handle).trim()

            if (!normalizedHandle) {
                return
            }

            /*
             * `value` is suggestionUserData.
             * `messageContentDraftVAL` is the message string and must not be
             * passed to Object.assign as an object.
             */
            const updatedValue = Object.assign(
                {},
                this.value || {},
                {
                    handle: normalizedHandle + ' '
                }
            )

            this.$emit('input', updatedValue)
            this.$emit('select', user)
            this.$emit('close')

        }
    }
}
</script>

<style lang="scss" scoped>
.suggestion_user_list_wrp {
    position: absolute;
    right: 0;
    bottom: calc(100% + 7px);
    left: 0;
    z-index: 10;
    padding: 5px 0;
    background: #1d2226;
    border-radius: 5px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);

    .suggestion_user_list_item {
        max-height: 250px;
        margin: 0;
        padding: 0;
        overflow-y: auto;
        list-style: none;

        li {
            padding: 5px 15px;
            cursor: pointer;

            &:hover,
            &:focus {
                background: #87cefa;
                outline: none;

                .suggestion_user_info_name,
                .suggestion_user_info_email {
                    color: #000;
                }
            }

            // &:focus {
            //     box-shadow: inset 0 0 0 2px #fff;
            // }
        }
    }

    .suggestion_user_info {
        display: block;

        span {
            display: block;
        }
    }

    .suggestion_user_info_name {
        margin-bottom: 0;
        color: #fff;
        font-size: 14px;
        line-height: 1;

        &--team {
            text-transform: capitalize;
        }
    }

    .suggestion_user_info_email {
        margin-top: 1px;
        color: rgba(255, 255, 255, 0.5);
        font-size: 12px;
        white-space: normal;
        word-break: break-word;
    }
}
</style>
